<script>
export default {
    name: "AdmissionHistoryReport",
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <li>Patient Reports: Admission History Report</li>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">Patient Reports: Admission History Report</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap">
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input type="text" id="grid-search" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" id="grid-date-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-date-to" class="label-control">To:</label>
                  <input type="date" id="grid-date-to" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-admitted-by" class="label-control">Admitted By:</label>
                  <tail-select>
                      <template v-slot:field>
                          <select id="grid-admitted-by" class="input-control input-sm text-xs">
                              <option value=""></option>
                          </select>
                      </template>
                  </tail-select>
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-ward" class="label-control">Ward:</label>
                  <tail-select>
                      <template v-slot:field>
                          <select id="grid-ward" class="input-control input-sm text-xs">
                              <option value=""></option>
                          </select>
                      </template>
                  </tail-select>
              </div>
              <div class="md:w-1/12 sm:w-full p-1 pt-3 text-center">
                  <button class="btn-sm btn-info text-sm mt-2 rounded"><i class="fa fa-filter"></i> Filter</button>
              </div>
          </div>
          <div class="w-full overflow-auto">
              <table class="table table-bordered table-hover">
                  <thead class="bg-indigo-400 text-sm">
                        <tr>
                            <th class="p-tiny">PID</th>
                            <th class="p-tiny">NAMES</th>
                            <th class="p-tiny">IP NO</th>
                            <th class="p-tiny">OP NO</th>
                            <th class="p-tiny">ID NO</th>
                            <th class="p-tiny">DOB</th>
                            <th class="p-tiny">MOBILE</th>
                            <th class="p-tiny">INPATIENT</th>
                            <th class="p-tiny">VISITS</th>
                            <th class="p-tiny">ADMISSIONS</th>
                            <th class="p-tiny">ACTION</th>
                        </tr>
                  </thead>
                  <tbody class="text-xs">
                      <tr>
                          <td class="p-tiny"></td>
                          <td class="p-tiny"></td>
                          <td class="p-tiny"></td>
                          <td class="p-tiny"></td>
                          <td class="p-tiny"></td>
                          <td class="p-tiny"></td>
                          <td class="p-tiny"></td>
                          <td class="p-tiny"></td>
                          <td class="p-tiny"></td>
                          <td class="p-tiny"></td>
                          <td class="p-tiny"></td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>